@if (service.isEmptyProgram()) {
  <app-card-empty [icon]="iconEmptyProgram" text="Belum terdapat Program Target."></app-card-empty>
} @else {
  <app-card [cardBodyClasses]="'pt-2'" [header]="true">
    <ng-container cardHeader>
      <app-program-target-filter
        (actionSearch)="handleSearch($event)"
        (actionApplyFilter)="handleApplyFilter($event)"
      ></app-program-target-filter>
    </ng-container>
    <ng-container cardBody>
      @if (service.isEmptySearchFilterResult()) {
        <app-card-empty
          [icon]="iconEmptyProgram"
          text="Program Marketing tidak ditemukan."
        ></app-card-empty>
      } @else {
        <app-program-target-table
          (actionDetail)="handleOpenDetailProgram($event)"
        ></app-program-target-table>
        <app-program-target-pagination
          (pageChange)="handlePageChange($event)"
        ></app-program-target-pagination>
      }
    </ng-container>
  </app-card>
  <app-modal-detail-distributor
    #modalDetailProgram
    (openInvoiceDetail)="handleOpenDetailInvoice()"
    (openOtherRewards)="handleOpenOtherRewards()"
    (openPotentialPo)="handleOpenPotentialPo()"
  ></app-modal-detail-distributor>
  <app-modal-nilai-invoice
    #modalDetailInvoice
    (closed)="modalDetailProgram.setHidden(false)"
  ></app-modal-nilai-invoice>
  <app-modal-potential-po
    #modalPotentialPo
    (closed)="modalDetailProgram.setHidden(false)"
  ></app-modal-potential-po>
  <app-modal-hadiah-lainnya
    #modalOtherRewards
    (closed)="modalDetailProgram.setHidden(false)"
  ></app-modal-hadiah-lainnya>
}
